import React, { useState } from "react";

import BtnClear from "../btn-clear";

const InputGroup = ({ id, val, title, units, _key, onChanged, comment, hidden, clearable = false, min = 0, max = undefined }) => {
    const _val = val === null || val === undefined || isNaN(val) ? "" : val;
    const [inputVal, setVal] = useState("");
    if (_val !== inputVal) setVal(_val);

    const readOnly = !_key || !onChanged;

    const label = title ? <label htmlFor={id}>{title}</label> : null;
    const input = readOnly ? (
        <input type="number" id={id} className="ctrl-input" readOnly title={comment} value={inputVal} />
    ) : (
        <input
            type="number"
            id={id}
            className="ctrl-input"
            min={min}
            max={max}
            value={inputVal}
            onChange={e => {
                setVal(e.target.value);
                onChanged(id, { [_key]: +e.target.value });
            }}
        />
    );
    const unitSpan = units ? <span className="ctrl-units">{units}</span> : null;

    return (
        <div hidden={hidden === true} className="ctrl-input-group">
            {label}
            {input}
            {unitSpan}

            {!readOnly && clearable && (
                <BtnClear
                    onClick={e => {
                        setVal("");
                        onChanged(id, { [_key]: "" });
                    }}
                />
            )}
        </div>
    );
};

export default InputGroup;
